import { useCallback } from "react";
import { usePersistentChatStore } from "src/stores/persistentChatStore";
import type { CommentingData } from "src/stores/persistentChatStore";
import {
  computeCommentingToolRunningDisplayProgress,
  isCommentingProgressTool,
} from "./commentingProgress";
import { useTimedPhaseDisplayProgress } from "./useTimedPhaseDisplayProgress";

/** Display progress for the commenting card (SSE phases + in-tool time creep). */
export function useCommentingDisplayProgress(commenting: CommentingData | undefined): number {
  const phaseProgress = usePersistentChatStore((s) => s.commentingProgress);
  const toolStartedAt = usePersistentChatStore((s) => s.commentingToolStartedAt);
  const toolRuns = usePersistentChatStore((s) => s.toolRuns);
  const active = commenting?.status === "in_progress";

  const matchesTool = useCallback(
    (toolName: string) => isCommentingProgressTool(toolName),
    [],
  );

  const computeToolRunningProgress = useCallback(
    (phase: number, startedAt: number, toolName: string) =>
      computeCommentingToolRunningDisplayProgress(phase, startedAt, toolName),
    [],
  );

  return useTimedPhaseDisplayProgress({
    active: Boolean(active),
    phaseProgress,
    toolStartedAt,
    toolRuns,
    matchesTool,
    computeToolRunningProgress,
  });
}
